export default __webpack_public_path__ + "static/media/MaskGroup5@2x.c5446872.png";